export const eventTypes = [
  { value: 'alternative_medicine', label: 'Alternative Medicine' },
  { value: 'aromatherapy_classes', label: 'Aromatherapy Classes' },
  { value: 'cacao_ceremony', label: 'Cacao Ceremony' },
  { value: 'herbal_medicine_workshops', label: 'Herbal Medicine Workshops' },
  { value: 'community_social_wellness', label: 'Community and Social Wellness' },
  { value: 'crossfit', label: 'CrossFit' },
  { value: 'pilates', label: 'Pilates' },
  { value: 'spinning', label: 'Spinning' },
  { value: 'yoga', label: 'Yoga' },
  { value: 'zumba', label: 'Zumba' },
  { value: 'mindfulness_retreats', label: 'Mindfulness Retreats' },
  { value: 'stress_management_workshops', label: 'Stress Management Workshops' },
  { value: 'breathwork_workshops', label: 'Breathwork Workshops' },
  { value: 'ecstatic_dance', label: 'Ecstatic Dance' },
  { value: 'eft_tapping', label: 'EFT Tapping' },
  { value: 'meditation', label: 'Meditation' },
  { value: 'qigong', label: 'Qigong' },
  { value: 'singing_circles', label: 'Singing Circles' },
  { value: 'tai_chi', label: 'Tai Chi' },
  { value: 'cooking_classes', label: 'Cooking Classes' },
  { value: 'detox_programs', label: 'Detox Programs' },
  { value: 'nutrition_seminars', label: 'Nutrition Seminars' },
  { value: 'vegetarian_vegan_workshops', label: 'Vegetarian/Vegan Workshops' },
  { value: 'forest_bathing', label: 'Forest Bathing Sessions' },
  { value: 'hiking_groups', label: 'Hiking Groups' },
  { value: 'nature_therapy_walks', label: 'Nature Therapy Walks' },
  { value: 'wellness_retreats', label: 'Wellness Retreats' },
  { value: 'day_spa_packages', label: 'Day Spa Packages' },
  { value: 'sound_bath', label: 'Sound Bath' },
  { value: 'weekend_retreats', label: 'Weekend Retreats' },
  { value: 'wellness_festivals', label: 'Wellness Festivals' }
];